<template>
  <modal title="Update Hotel" @close="$emit('close')" size="lg">
    <template #content>
      <loadArea
        v-if="
          !load ||
            countries == null ||
            destinationTowns == null ||
            softwares == null ||
            hotelGroups == null ||
            customers == null
        "
      ></loadArea>
      <template
        v-if="
          load &&
            countries != null &&
            destinationTowns != null &&
            softwares != null &&
            hotelGroups != null &&
            customers != null
        "
      >
        <ul class="nav nav-tabs profile-tab border-bottom">
          <li class="nav-item">
            <a
              href="javascript:;"
              @click="tab = 'Detail'"
              :class="{ active: tab == 'Detail' }"
              class="nav-link"
              >Detail</a
            >
          </li>
          <li class="nav-item">
            <a
              href="javascript:;"
              @click="tab = 'MatchList'"
              :class="{ active: tab == 'MatchList' }"
              class="nav-link"
              >Match List</a
            >
          </li>
        </ul>
        <Form
          method="dialog"
          v-slot="{ errors }"
          class="floating-labels p-1rem row"
          ref="form"
          v-if="tab == 'Detail'"
        >
          <div class="col-6">
            <formGroup
              :title="'Name'"
              v-model="model.Name"
              :errors="errors"
              :rules="{ required: true }"
              @keydown.enter="save"
            ></formGroup>

            <formGroup
              :title="'Star'"
              v-model="model.Star"
              :errors="errors"
              :rules="{ required: true }"
              @keydown.enter="save"
            ></formGroup>
            <formGroup
              :title="'CustomerId'"
              :as="'select'"
              :disabled="customers.length == 0"
              :buttons="true"
              v-model="model.CustomerId"
              :errors="errors"
              @keydown.enter="save"
            >
              <template #input>
                <option :value="null"></option>
                <option
                  v-for="item in customers"
                  :value="item.Id"
                  :key="item.Code"
                  >{{ item.Name }}</option
                >
              </template>
              <template #buttons>
                <button
                  type="button"
                  @click="addCustomerOpen = true"
                  class="btn waves-effect waves-light btn-success"
                >
                  <i class="fas fa-plus"></i>
                </button>
              </template>
            </formGroup>
            <formGroup
              :title="'RoomCount'"
              type="number"
              v-model="model.RoomCount"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
            <div class="row">
              <div class="col-6">
                <formGroup
                  :title="'EnterHour'"
                  type="number"
                  v-model="model.EnterHour"
                  :errors="errors"
                  @keydown.enter="save"
                ></formGroup>
              </div>
              <div class="col-6">
                <formGroup
                  :title="'EnterMinute'"
                  type="number"
                  v-model="model.EnterMinute"
                  :errors="errors"
                  @keydown.enter="save"
                ></formGroup>
              </div>
              <div class="col-6">
                <formGroup
                  :title="'ExitHour'"
                  type="number"
                  v-model="model.ExitHour"
                  :errors="errors"
                  @keydown.enter="save"
                ></formGroup>
              </div>
              <div class="col-6">
                <formGroup
                  :title="'ExitMinute'"
                  type="number"
                  v-model="model.ExitMinute"
                  :errors="errors"
                  @keydown.enter="save"
                ></formGroup>
              </div>
            </div>
            <formGroup
              :title="'KolayrezNotesTo'"
              v-model="model.KolayrezNotesTo"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
            <formGroup
              :title="'HotelGroupId'"
              :as="'select'"
              v-model="model.HotelGroupId"
              :disabled="hotelGroups.length == 0"
              :buttons="true"
              :errors="errors"
              @keydown.enter="save"
            >
              <template #input>
                <option
                  v-for="item in hotelGroups"
                  :value="item.Id"
                  :key="item.Code"
                  >{{ item.Name }}</option
                >
              </template>
              <template #buttons>
                <button
                  type="button"
                  @click="addHotelGroupOpen = true"
                  class="btn waves-effect waves-light btn-success"
                >
                  <i class="fas fa-plus"></i>
                </button>
              </template>
            </formGroup>
          </div>
          <div class="col-6 border-left">
            <div class="row">
              <div class="col-6">
                <formGroup
                  :title="'CountryId'"
                  :as="'select'"
                  :disabled="countries.length == 0"
                  :buttons="true"
                  v-model="model.CountryId"
                  :errors="errors"
                  :rules="{ required: true }"
                  @keydown.enter="save"
                >
                  <template #input>
                    <option :value="null"></option>
                    <option
                      v-for="item in countries"
                      :value="item.Id"
                      :key="item.Code"
                      >{{ item.Name }}</option
                    >
                  </template>
                  <template #buttons>
                    <button
                      type="button"
                      @click="addCountriesOpen = true"
                      class="btn waves-effect waves-light btn-success"
                    >
                      <i class="fas fa-plus"></i>
                    </button>
                  </template>
                </formGroup>
              </div>
              <div class="col-6">
                <formGroup
                  :title="'DestinationTownId'"
                  :as="'select'"
                  :disabled="
                    destinationTowns.length == 0 || model.CountryId == null
                  "
                  v-model="model.DestinationTownId"
                  :errors="errors"
                  @keydown.enter="save"
                >
                  <template #input>
                    <option :value="null"></option>
                    <template v-for="item in destinationTowns">
                      <option
                        :value="item.Id"
                        :key="item.Code"
                        v-if="model.CountryId == item.CountryId"
                        >{{ item.Name }}</option
                      >
                    </template>
                  </template>
                </formGroup>
              </div>
              <div class="col-6">
                <formGroup
                  :title="'Long'"
                  v-model="model.Long"
                  :errors="errors"
                  @keydown.enter="save"
                ></formGroup>
              </div>
              <div class="col-6">
                <formGroup
                  :title="'Lat'"
                  v-model="model.Lat"
                  :errors="errors"
                  @keydown.enter="save"
                ></formGroup>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <formGroup
                  :title="'SletatId'"
                  v-model="model.SletatId"
                  :errors="errors"
                  @keydown.enter="save"
                ></formGroup>
              </div>
              <div class="col-4">
                <formGroup
                  :title="'TourvisorId'"
                  v-model="model.TourvisorId"
                  :errors="errors"
                  @keydown.enter="save"
                ></formGroup>
              </div>
              <div class="col-4">
                <formGroup
                  :title="'AviantaId'"
                  v-model="model.AviantaId"
                  :errors="errors"
                  @keydown.enter="save"
                ></formGroup>
              </div>
            </div>
            <formGroup
              :title="'SoftwareId'"
              :as="'select'"
              v-model="model.SoftwareId"
              :disabled="softwares.length == 0"
              :buttons="true"
              :errors="errors"
              @keydown.enter="save"
            >
              <template #input>
                <option
                  v-for="item in softwares"
                  :value="item.Id"
                  :key="item.Code"
                  >{{ item.Name }}</option
                >
              </template>
              <template #buttons>
                <button
                  type="button"
                  @click="addSoftwareOpen = true"
                  class="btn waves-effect waves-light btn-success"
                >
                  <i class="fas fa-plus"></i>
                </button>
              </template>
            </formGroup>
            <formGroup
              :title="'P1'"
              v-model="model.P1"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
            <formGroup
              :title="'P2'"
              v-model="model.P2"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
            <formGroup
              :title="'P3'"
              v-model="model.P3"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
            <formGroup
              :title="'P4'"
              v-model="model.P4"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
            <formGroup
              :title="'P5'"
              v-model="model.P5"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
            <formGroup
              :title="'TempReservationCode'"
              v-model="model.TempReservationCode"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
          </div>
          <div class="m-t-10"></div>
          <div class="col-auto">
            <formGroup
              :title="'PMSIntegration'"
              :as="'checkbox'"
              v-model="model.PMSIntegration"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
          </div>
          <div class="col-auto">
            <formGroup
              :title="'SyncErrorMailSent'"
              :as="'checkbox'"
              v-model="model.SyncErrorMailSent"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
          </div>
          <div class="col-auto">
            <formGroup
              :title="'SyncError'"
              :as="'checkbox'"
              v-model="model.SyncError"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
          </div>
          <div class="col-auto">
            <formGroup
              :title="'Active'"
              :as="'checkbox'"
              v-model="model.Active"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
          </div>
        </Form>
        <match v-if="tab == 'MatchList'" :setModel="setModel"></match>
      </template>
    </template>
    <template
      v-if="
        tab == 'Detail' &&
          load &&
          countries != null &&
          destinationTowns != null &&
          softwares != null &&
          hotelGroups != null &&
          customers != null
      "
      #foot
    >
      <Btn class="btn-success btn-md" @click="save" :process="process"
        >Update Hotel</Btn
      >
    </template>
  </modal>
  <addCountries
    v-if="addCountriesOpen"
    @close="addCountriesOpen = false"
    @add="countries.push({ Id: $event.Id, Name: $event.Name })"
  ></addCountries>
  <addSoftware
    v-if="addSoftwareOpen"
    @close="addSoftwareOpen = false"
    @add="softwares.push({ Id: $event.Id, Name: $event.Name })"
  ></addSoftware>
  <addHotelGroup
    v-if="addHotelGroupOpen"
    @close="addHotelGroupOpen = false"
    @add="hotelGroups.push({ Id: $event.Id, Name: $event.Name })"
  ></addHotelGroup>
  <addCustomer
    v-if="addCustomerOpen"
    @close="addCustomerOpen = false"
    @add="customers.push({ Id: $event.Id, Name: $event.Name })"
  ></addCustomer>
</template>

<script>
import addCountries from "@/views/countries/upsert";
import addSoftware from "@/views/softwares/upsert";
import addHotelGroup from "@/views/hotelGroups/upsert";
import addCustomer from "@/views/customers/add";
import match from "./match";
export default {
  components: { addCountries, addSoftware, addHotelGroup, addCustomer, match },
  props: {
    setModel: Object,
  },
  data() {
    return {
      load: false,
      tab: "Detail",
      model: {
        Id: null,
        Name: "",
        CountryId: null,
        DestinationTownId: null,
        Star: "",
        SletatId: null,
        TourvisorId: null,
        AviantaId: null,
        Long: null,
        Lat: null,
        Active: true,
        PMSIntegration: true,
        SoftwareId: 1,
        P1: "",
        P2: "",
        P3: "",
        P4: "",
        P5: "",
        LastSyncTime: "",
        TempReservationCode: "",
        CustomerId: null,
        SyncErrorMailSent: false,
        RoomCount: null,
        EnterHour: null,
        EnterMinute: null,
        ExitHour: null,
        ExitMinute: null,
        SyncError: false,
        KolayrezNotesTo: "",
        HotelKey: "",
        HotelGroupId: null,
      },
      errs: {},
      process: false,
      countries: null,
      addCountriesOpen: false,
      destinationTowns: null,
      softwares: null,
      addSoftwareOpen: false,
      hotelGroups: null,
      addHotelGroupOpen: false,
      customers: null,
      addCustomerOpen: false,
    };
  },
  created() {
    this.$appAxiosAdmin.get(`Hotels/` + this.setModel.Id).then((response) => {
      this.model = response.data;
      this.load = true;
    });
    this.$appAxiosAdmin.get(`Countries`).then((response) => {
      this.countries = response.data;
    });
    this.$appAxiosAdmin.get(`DestinationTowns`).then((response) => {
      this.destinationTowns = response.data;
    });
    this.$appAxiosAdmin.get(`Softwares`).then((response) => {
      this.softwares = response.data;
    });
    this.$appAxiosAdmin.get(`HotelGroups`).then((response) => {
      this.hotelGroups = response.data;
    });
    this.$appAxiosAdmin.get(`CustomersNames`).then((response) => {
      this.customers = response.data;
    });
  },
  methods: {
    save() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.process = true;
          this.$appAxiosAdmin
            .put(`Hotels`, this.model)
            .then((response) => {
              this.process = false;
              this.$swal({
                icon: "success",
                title: "Success",
                text:
                  this.setModel != undefined
                    ? "The hotel has been successfully updated."
                    : "The hotel has been successfully added.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              if (this.setModel != undefined) {
                this.$emit("update", response.data);
              } else {
                this.$emit("add", response.data);
              }
              this.$emit("close");
            })
            .catch((err) => {
              this.process = false;
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>

<style>
.floating-labels.row > div > .row {
  margin: 0 -5px;
}
.floating-labels.row > div > .row > div {
  padding: 0 5px;
}
</style>
